





































import { Component, Vue, Model, Watch, Prop } from 'vue-property-decorator';
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions';
import BootstrapBlockquoteNode from '@/services/BootstrapBlockQuote';
import Icon from './Icon.vue';

@Component({
    components: {
        EditorMenuBar,
        EditorContent,
        Icon
    }
})
export default class UserNotificationForm extends Vue {
    @Prop({default: false}) public readOnly!: boolean;
    @Model('change', { type: String }) public content!: string;

    public editor: any | null = null;

    @Watch('content')
    public onContentChanged(val: string) {
      if (val !== this.editor.getHTML()) {
        this.editor.setContent(val);
      }
    }

    public mounted(): void {
        this.editor = new Editor({
            editable: this.readOnly,
            extensions: [
                new BootstrapBlockquoteNode(),
                new BulletList(),
                new HardBreak(),
                new Heading({ levels: [1, 2, 3] }),
                new HorizontalRule(),
                new ListItem(),
                new OrderedList(),
                new Bold(),
                new Italic(),
                new Link(),
                new Strike(),
                new Underline(),
                new History()
            ],
            onUpdate: ( { state, getHTML, getJSON, transaction }: any ) => {
              this.$emit('change', getHTML());
            }
        });
    }

    public publicbeforeDestroy(): void {
        this.editor.destroy();
    }
}
